<template>
  <div v-if="_includes(['doc', 'docx', 'xls', 'xlsx', 'zip'], type)" class="row py-3 text-center">
    <div class="col-12">
      <i class="far fa-file-alt"></i>
      <span class="text-uppercase ms-2">
        {{ component.text || type }}
      </span>
    </div>
    <div class="col-12 mt-4">
      <a
        :href="`https://skyier-bucket.s3.eu-west-1.amazonaws.com/${component.file}`"
        class="btn btn-primary"
      >
        {{ 'Download' | translate }}
      </a>
    </div>
  </div>
  <div v-else-if="type === 'pdf'">
    <div v-if="noDownload">
      <div class="col-12">
        <i class="far fa-file-alt"></i>
        <span class="text-uppercase ms-2">
          {{ component.text || type }}
        </span>
      </div>
      <div class="col-12 mt-4">
        <div class="ratio ratio-1x1">
          <iframe
            :src="`https://notapanda.github.io/skyier-pdf-viewer/?url=${encodeURI(path)}`"
            title="Embed"
            allowfullscreen
          ></iframe>
        </div>
      </div>
    </div>
    <div v-else-if="!watermark" class="text-center">
      <div class="col-12">
        <i class="far fa-file-alt"></i>
        <span class="text-uppercase ms-2">
          {{ component.text || type }}
        </span>
      </div>
      <div class="col-12 mt-4">
        <a
          :href="`https://skyier-bucket.s3.eu-west-1.amazonaws.com/${component.file}`"
          target="_blank"
          class="btn btn-primary"
        >
          {{ 'Download' | translate }}
        </a>
      </div>
    </div>
    <div v-else class="text-center">
      <div class="col-12">
        <i class="far fa-file-alt"></i>
        <span class="text-uppercase ms-2">
          {{ component.text || type }}
        </span>
      </div>
      <div class="col-12 mt-4">
        <div v-if="working">
          <button class="btn btn-primary" type="button" disabled>
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          </button>
        </div>
        <div v-else>
          <a v-if="is_prepared" :href="watermarked_url" target="_blank" class="btn btn-primary">
            {{ 'Download' | translate }}
          </a>

          <button v-else class="btn btn-danger" @click="prepare">
            {{ 'Prepare file for download' | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
  <div v-else-if="type === 'mp3'" class="row text-center py-3">
    <div class="col-12">
      <i class="fas fa-volume-up"></i>
      <span class="text-uppercase ms-2">
        {{ component.text || type }}
      </span>
    </div>
    <div class="col-12 mt-4">
      <audio style="width: 100%" controls controlsList="nodownload" :src="path" ref="audio">
        Your browser does not support the
        <code>audio</code>
        element.
      </audio>
    </div>
    <div class="col-12 mt-4" v-if="component.data.download">
      <a :href="path" :download="filename" target="_blank" class="btn btn-primary">
        {{ 'Download' | translate }}
      </a>
    </div>
  </div>
</template>

<script>
import slugify from 'slugify'
import _ from 'lodash'

export default {
  props: ['component'],
  data() {
    if (this.component.file) {
      return {
        path: `https://skyier-bucket.s3.eu-west-1.amazonaws.com/${this.component.file}`,
        type: this.component.file.split('.').pop(),
        is_prepared: false,
        working: false,
        watermarked_url: '',
      }
    }
    return {
      path: `/`,
      type: 'txt',
    }
  },
  methods: {
    _includes: _.includes,
    prepare() {
      if (this.type === 'pdf' && this.watermark && this.email) {
        this.working = true
        axios.post(`/${this.courseSlug}/download/${this.component.id}`).then(({ data }) => {
          this.watermarked_url = data.url
          setTimeout(() => {
            this.is_prepared = true
            this.working = false
          }, 3000)
          setTimeout(() => {
            this.is_prepared = false
            this.working = false
            this.watermarked_url = ''
          }, 8 * 60 * 1000)
        })
      }
    },
  },
  computed: {
    courseSlug() {
      return _.get(this.$store, 'state.course.slug', null)
    },
    noDownload() {
      return _.get(this.component, 'data.no_download', false)
    },
    watermark() {
      return _.get(this.component, 'data.watermark', false)
    },
    email() {
      return _.get(this.$store, 'state.user.email', null)
    },
    filename() {
      return `${slugify(this.component.text || 'file')}.${this.type}`.toLowerCase()
    },
  },
}
</script>
